jQuery(document).ready(function($){

	$('.toggle-apply').on('click',function(e){
		e.preventDefault();
		$('#' + $(this).data('id') ).slideToggle();
		$(this).toggleClass('active');
		var closest = $(this).closest('tr');
		$(closest).toggleClass('active');
		$(closest).next('tr').toggleClass('active');
	});


// ================================================================================================
// supporting excel functions
// ================================================================================================

	// ABS (absolute value) function
	function ABS(x) {
	  if (x < 0) {
	    return -x;
	  } else {
	    return x;
	  }
	}

	// FV (future value) function
	function FV(rate, periods, payment, value, type) {
	  value = value || 0;
	  type = type || 0;

	  var result;
	  if (rate === 0) {
	    result = value + payment * periods;
	  } else {
	    var term = Math.pow(1 + rate, periods);
	    if (type === 1) {
	      result = value * term + payment * (1 + rate) * (term - 1) / rate;
	    } else {
	      result = value * term + payment * (term - 1) / rate;
	    }
	  }
	  return -result;
	};

	// PMT function
	function PMT(rate, periods, value, fv, type) {
	  fv = (typeof fv === 'undefined') ? 0 : fv;
	  type = (typeof type === 'undefined') ? 0 : type;
	  return -(rate * value) / (1 - Math.pow(1 + rate, -periods));
	}

	// CUMIPMT function
	function CUMIPMT(rate, periods, value, start, end, type) {
	  rate = eval(rate);
	  periods = eval(periods);
	  if (rate <= 0 || periods <= 0 || value <= 0) return '#NUM!';
	  if (start < 1 || end < 1 || start > end) return '#NUM!';
	  if (type !== 0 && type !== 1) return '#NUM!';
	  var payment = PMT(rate, periods, value, 0, type);
	  var interest = 0;
	  interest = 0;
	  if(start === 1) {
	    if(type === 0) {
	      interest = -value;
	      start++;
	    }
	  }
	  for (var i = start; i <= end; i++) {
	    if (type === 1) {
	      interest += FV(rate, i - 2, payment, value, 1 ) - payment;
	    } else {
	      interest += FV(rate, i - 1, payment, value, 0 );
	    }
	  }
	  interest *= rate;
	  return interest;
	}

	// Example usage
	var rate = (2.75 / 12) / 100;  // Monthly interest rate: 0.00229167
	var periods = 22 * 12;  // Number of periods (months): 264
	var value = 500000;  // Present value (loan amount): 500,000
	var start = 1;  // Start period: 1
	var type = 0;  // interest added at end of period?
	var end = periods;  // End period: 264

	var cumipmt = CUMIPMT(rate, periods, value, start, end, type);
	console.log('The cumulative interest paid from period ' + start + ' to ' + end + ' is: ' + cumipmt.toFixed(2));
// console.log('The cumulative interest paid from period ' + start + ' to ' + end + ' is: ' + cumipmt);
// ================================================================================================




// ================================================================================================
// Generic calculator functions
// ================================================================================================




	function clean_numeric( field , fetch ){

		if(fetch){
			field = $('#'+field);
		}

		if(typeof($(field).val()) != "undefined" ){

			$(field).removeClass('border-red');			

			$('#form_error').slideUp();

			var $value = $(field).val();
			$value = $value.replace(/,/g, '');

			if( $.isNumeric( $value ) ){
				$(field).parent().removeClass('error');			
				$(field).parent().addClass('check');			
				$(field).val( formatNumber($value, $(field).data('dp') ) );			
				return parseFloat($value);

			}else if( $.trim($value) == "" ){
				if($(field).prop('required')==false){			
					// leave number alone
					$(field).parent().removeClass('error');			
					$(field).parent().removeClass('check');			
					$(field).val( '' );			
					return 0;
				}else{
					$(field).parent().removeClass('check');			
					$(field).parent().addClass('error');			
					return -1;
				}

			}else{
				// flag as error and focus - and return false
				$(field).parent().removeClass('check');			
				$(field).parent().addClass('error');			
				$(field).focus();
				return -1;

			}

		}

		return -1;

	}


	function get_check( field_name , fetch ){

		if(fetch){
			field = $('#'+field_name);
		}else{
			field = field_name;			
		}

		var $val = $('input[name="'+field_name+'"]:checked').val();
		if(typeof($val) != "undefined" ){
			$('input[name="'+field_name+'"]').parent().removeClass('check-error');
			return $val
		}else{
			$('input[name="'+field_name+'"]').parent().addClass('check-error');
		}

		return -1;
	}



	function get_checkbox_val( field_name ){

		var $val = $('input[name="'+field_name+'"]:checked').val();
		if(typeof($val) != "undefined" ){
			return $val
		}
		return -1;
	}


	function get_numeric_val(field_name, dflt) {
	    if (typeof(dflt) == "undefined") dflt = -1;
	    var $val = $('input[name="' + field_name + '"]').val();
	    if (typeof($val) != "undefined") {
	        return Number($val.replace(/,/g, ''));
	    }
	    return dflt;
	}


// ================================================================================================
// Listeners
// ================================================================================================


	$('.field-numeric').on('blur',function(e){
		clean_numeric( $(this) );
	});

	$('.mega-radio input').on('change',function(e){
		// console.log($(this).prop('name'));
		var $name = $(this).prop('name');
		$('.mega-radio input[name="'+$name+'"]').each(function(){
			$(this).parent().removeClass('check-error');	
			if($(this).prop('checked')){
				$(this).parent().addClass('on');
			}else{
				$(this).parent().removeClass('on');
			}
		});
	});


// ================================================================================================
// Rental Top-up Calculator
// ================================================================================================


// $('#calculate_buy_to_let_form #total_finance').on('change',function(e){
	// $('#rt_property_price')=$('#calculate_buy_to_let_form #total_finance').value();
// });
$('#calculate_buy_to_let_form #total_finance').on('change',function(e){
	$('#rt_finance_needed').val($('#calculate_buy_to_let_form #total_finance').val());
	clean_numeric($('rt_finance_needed'));	
});

$('#rt_eligibility input').on('change',function(e){
	var $rt_uk_resident	= get_checkbox_val('rt_uk_resident');
	var $rt_income	= get_checkbox_val('rt_income');
	var $rt_btl	= get_checkbox_val('rt_btl');

	var min_gross_income = document.getElementById('min_gross_income');
	var min_gross_income_input = document.getElementById('min_gross_income_input');

	if($rt_uk_resident == "int"){
		min_gross_income.innerText = '£100,000';
		min_gross_income_input.value = '£100,000';
	}else{
		min_gross_income.innerText = '£32,000';			
		min_gross_income_input.value = '£32,000';
	}

	// alert($rt_btl);
	// if( $rt_uk_resident && $rt_income>0 && $rt_btl>0 ){
	if($rt_uk_resident=="int" && $rt_income>0 && $rt_btl>0){
		// new status, allow if int and btl
		$('#rt_not_eligible').hide();
		$('#rt_section_a').slideDown();
	}else if( $rt_uk_resident && $rt_income>0 && $rt_btl>0 ){
		$('#rt_not_eligible').hide();
		$('#rt_section_a').slideDown();
	// }else if($rt_income==0 || $rt_btl==0){
	}else if(!$rt_uk_resident || $rt_income==0 || $rt_btl==0){
		$('#rt_not_eligible').slideDown();
		$('#rt_section_a').hide();
		$('#rt_section_b').hide();
	}else{
		$('#rt_not_eligible').hide();
		$('#rt_section_a').hide();
		$('#rt_section_b').hide();
	}
});

if($('#rt_initial_product_rate').length){
	$('#product_rate').on('change',function(e){
		product_rate_change();
	});
	$('#five_year_yes').on('change',function(e){
		product_rate_change();
	});
	$('#five_year_no').on('change',function(e){
		product_rate_change();
	});
}

function product_rate_change(){
	var five_year = get_check('five_year', true);
	var pr_val = $('#product_rate').val();
	if(pr_val < window.default_rate && five_year==0) pr_val = window.default_rate;
	// console.log("five_year"+ five_year);
	// console.log("window.default_rate"+ window.default_rate);
	// console.log("pr_val"+ pr_val);
	$('#rt_initial_product_rate').val(pr_val);
}

if($('#rt_monthly_rent').length)
$('#monthly_rental').on('change',function(e){
	$('#rt_monthly_rent').val($('#monthly_rental').val());
});

// $('input.rt_uk_resident').on('change',function(e){
// 	var $val = $('.rt_uk_resident:checked').val();
// 	if( $val == 'int' ){
// 		$('#rt_income_container').slideUp();
// 	}else{
// 		$('#rt_income_container').slideDown();
// 	}
// });


$('input.rt_uk_resident').on('change',function(e){
	var $val = $('input.rt_uk_resident:checked').val();
	if($val=='int'){
		$('input.rt_taxpayer_status').prop('disabled',true);
		$('input.rt_taxpayer_status').parent().addClass('check-disabled');
		$('input.rt_taxpayer_status_nonuk').prop('disabled',false);
		$('input.rt_taxpayer_status_nonuk').parent().removeClass('check-disabled');
		$('input.rt_taxpayer_status_nonuk').trigger('click');
	}else{
		$('input.rt_taxpayer_status').prop('disabled',false);
		$('input.rt_taxpayer_status').parent().removeClass('check-disabled');
	}
});




$('#rt_section_a input').on('change keyup',function(e){
	var $rt_application_type = get_checkbox_val('rt_application_type'); // individual limited
	var ftv = null;
	// if individual show tax status
	if($rt_application_type=='individual'){
		$('#rt_section_taxpayer').slideDown();
	}else{
		$('#rt_section_taxpayer').hide();
	}
	$('#rt_income_total').html('');
	$('#rt_expenses_total').html('');
	$('#rt_remaining_income').html('');
	$('#rt_section_b_eligible').hide();
	$('#rt_section_b_not_eligible').hide();
	$('#calc_affordability_values').hide();
	$('#rt_ftv').val('');
	$('#rt_fscr').val('');
	$('#rt_monthly_finance_rent_only').val('');
	$('#rt_section_a_eligible').hide();
	$('#rt_section_a_not_eligible').hide();
	$('#rt_section_b').hide();	
});


function clear_afford(){			
	$('#rt_monthly_top_up_amount').html('');
	$('#rt_applicant_1_income').val('');
	$('#rt_applicant_2_income').val('');
	$('#rt_expenses_rental_top_up').val('');
	for(i=1;i<14;i++){
		$('#rt_expenses_'+i).val('');
	}	
}

$('#rt_section_a_calc_now').on('click',function(e){
	$('#rt_section_b').hide();
	var $rt_application_type = get_checkbox_val('rt_application_type'); // individual limited
	var $rt_taxpayer_status	= get_checkbox_val('rt_taxpayer_status'); // basic higher
	var $rt_property_price= get_numeric_val('rt_property_price');
	var $rt_finance_needed= get_numeric_val('rt_finance_needed');
	var $rt_initial_product_rate= get_numeric_val('rt_initial_product_rate');
	var $rt_monthly_rent= get_numeric_val('rt_monthly_rent');
	var $rt_uk_resident	= get_checkbox_val('rt_uk_resident');

// console.log($rt_property_price);
// console.log($rt_finance_needed);
	var ftv = null;
	
	// if individual show tax status
	if($rt_application_type=='individual'){
		$('#rt_section_taxpayer').slideDown();
	}else{
		$('#rt_section_taxpayer').hide();
	}

	$('input[type="radio"][name="rt_taxpayer_status"]').parent().removeClass('error');
	if($rt_application_type=='individual' && $rt_taxpayer_status==-1 && $rt_property_price>0){
		$('input[type="radio"][name="rt_taxpayer_status"]').parent().addClass('check-error');
		$('#rt_section_b').hide();	
		return;
	}

	$('#rt_income_total').html('');
	$('#rt_expenses_total').html('');
	$('#rt_remaining_income').html('');
	$('#rt_section_b_eligible').hide();
	$('#rt_section_b_not_eligible').hide();
	$('#calc_affordability_values').hide();

	// alert($rt_finance_needed);
	// alert($rt_property_price);
	if($rt_finance_needed>0 && $rt_property_price>0){
		ftv = 100*($rt_finance_needed/$rt_property_price);
		// $('#rt_ftv').val((Math.round(ftv*100,2)/100));
		$('#rt_ftv').val(formatNumber( ftv ,2 ));
		// if(ftv<=80){
			// allow coz low ftv
			// console.log('Low FTV');
			// $('#rt_ftv').parent().removeClass('error');
			// $('#rt_section_a_eligible').slideDown();
			// $('#rt_section_a_not_eligible').hide();
			// $('#rt_section_b').hide();	
			// $('#rt_not_eligible_2').hide();	
		// }else 
		$('#rt_ftv').parent().removeClass('error');		
		if(ftv>80){
			$('#rt_ftv').parent().addClass('error');
			$('#rt_not_eligible_2').show();
			$('#rt_not_eligible_area').hide();
			$('#rt_section_a_eligible').hide();
		}else if($rt_initial_product_rate && $rt_application_type && $rt_taxpayer_status){
			var mfro = (($rt_initial_product_rate*0.01) * ($rt_finance_needed))*(1/12) ; //month finance r o
			$('#rt_not_eligible_2').hide();
			$('#rt_not_eligible_area').show();
			$('#rt_section_a_eligible').hide();
			$('#rt_monthly_finance_rent_only').val( formatNumber( mfro,0 ) );
			if($rt_monthly_rent>0){
				var fscr = $rt_monthly_rent / mfro;
				if(fscr) //$('#rt_fscr').val(Math.round( fscr*100 ));
						$('#rt_fscr').val(formatNumber( fscr*100 ,2 ));

				var minfscr = 0;
				var passfscr = 0;


				if( $rt_application_type=='limited' ){
					if( $rt_uk_resident=='uk' ) {
						minfscr = top_slicing_ltd_ukResidentMin;
						passfscr = top_slicing_ltd_ukResidentPass;
					}
					if( $rt_uk_resident=='expat' ) {
						minfscr = top_slicing_ltd_expatMin;
						passfscr = top_slicing_ltd_expatPass;
					}
					if( $rt_uk_resident=='int' ) {
						minfscr = top_slicing_ltd_internationalMin;
						passfscr = top_slicing_ltd_internationalPass;
					}
				} 
				else if( $rt_taxpayer_status=='basic' ){
					if( $rt_uk_resident=='uk' ) {
						minfscr = top_slicing_ukBasic_ukResidentMin;
						passfscr = top_slicing_ukBasic_ukResidentPass;
					}
					if( $rt_uk_resident=='expat' ) {
						minfscr = top_slicing_ukBasic_expatMin;
						passfscr = top_slicing_ukBasic_expatPass;
					}
					if( $rt_uk_resident=='int' ) {
						minfscr = top_slicing_ukBasic_internationalMin;
						passfscr = top_slicing_ukBasic_internationalPass;
					}
				}
				else if( $rt_taxpayer_status=='higher' ){
					if( $rt_uk_resident=='uk' ) {
						minfscr = top_slicing_ukHigher_ukResidentMin;
						passfscr = top_slicing_ukHigher_ukResidentPass;
					}
					if( $rt_uk_resident=='expat' ) {
						minfscr = top_slicing_ukHigher_expatMin;
						passfscr = top_slicing_ukHigher_expatPass;
					}
					if( $rt_uk_resident=='int' ) {
						minfscr = top_slicing_ukHigher_internationalMin;
						passfscr = top_slicing_ukHigher_internationalPass;
					}
				}
				else if( $rt_taxpayer_status=='nonuk' ){
					if( $rt_uk_resident=='uk' ) {
						minfscr = top_slicing_nonUk_ukResidentMin;
						passfscr = top_slicing_nonUk_ukResidentPass;
					}
					if( $rt_uk_resident=='expat' ) {
						minfscr = top_slicing_nonUk_expatMin;
						passfscr = top_slicing_nonUk_expatPass;
					}
					if( $rt_uk_resident=='int' ) {
						minfscr = top_slicing_nonUk_internationalMin;
						passfscr = top_slicing_nonUk_internationalPass;
					}
				}
				minfscr = parseFloat(minfscr.toFixed(4));

				console.log('FSCR: '+fscr+' - MinFSCR:' + minfscr + ' - MaxFSCR:' + passfscr);

				if( fscr>=passfscr ){
					console.log('Pass');
					$('#rt_section_a_eligible').slideDown();
					$('#rt_section_a_not_eligible').hide();
					clear_afford();			
					$('#rt_section_b').hide();						
				}
				else if(fscr<minfscr){ 
					console.log('Error - FSCR too low');
					$('#rt_section_a_eligible').hide();
					$('#rt_section_a_not_eligible').slideDown();
					clear_afford();			
					$('#rt_section_b').hide();	
				}
				else {
					// console.log('fscr:'+fscr);
					// console.log('passfscr:'+passfscr);
					console.log('Show results / assessment form (section b)');
					// var indhigher = (mfro * 1.45) - $rt_monthly_rent;
					// var indbasiccorp = ((mfro * 1.25) - $rt_monthly_rent);
					// var indnonuk = ((mfro * 1.30) - $rt_monthly_rent);
					var indhigher = (mfro * passfscr) - $rt_monthly_rent;
					var indbasiccorp = ((mfro * passfscr) - $rt_monthly_rent);
					var indnonuk = ((mfro * passfscr) - $rt_monthly_rent);

					// console.log('indbasiccorp'+indbasiccorp);
					// console.log('indhigher'+indhigher);
					if($rt_application_type=='individual' && $rt_taxpayer_status=='higher'){
						console.log('minfscr:',minfscr,'indhigher:',indhigher);
						$('#rt_monthly_top_up_amount').html('£'+(Math.ceil(indhigher,2)));
						$('#rt_expenses_rental_top_up').val(Math.ceil(indhigher,2));
					}else if($rt_application_type=='individual' && $rt_taxpayer_status=='nonuk'){
						console.log('minfscr:',minfscr,'nonukrate :',indnonuk);
						$('#rt_monthly_top_up_amount').html('£'+(Math.ceil(indnonuk,2)));
						$('#rt_expenses_rental_top_up').val(Math.ceil(indnonuk,2));
					}else{
						console.log('minfscr:',minfscr,'indbasiccorp:',indbasiccorp);
						$('#rt_monthly_top_up_amount').html('£'+(Math.ceil(indbasiccorp,2)));
						$('#rt_expenses_rental_top_up').val(Math.ceil(indbasiccorp,2));
					}
					$('#rt_section_a_eligible').hide();
					$('#rt_section_a_not_eligible').hide();
					$('#rt_section_b').slideDown();	
				}




				// // "If FSCR is 125% or greater for UK or Expat individual basic rate tax payer or company application - no requirement for section B onwards to be completed and just display message 2.
				// if( fscr>=1.25 && ((($rt_application_type=='individual' || $rt_application_type=='expat') && $rt_taxpayer_status=='basic') || $rt_application_type=='limited')  ){
				// 	console.log('individual basic or limited');
				// 	$('#rt_section_a_eligible').slideDown();
				// 	$('#rt_section_a_not_eligible').hide();
				// 	clear_afford();			
				// 	$('#rt_section_b').hide();	

				// // If FSCR is 145% or greater for individual Higher rate tax payer, no requirement for section B onwards to be completed, and just display message 2.
				// }else if( fscr>=1.45 && (($rt_application_type=='individual' || $rt_application_type=='expat') && $rt_taxpayer_status=='higher') ){
				// 	console.log('individual higher');
				// 	$('#rt_section_a_eligible').slideDown();
				// 	$('#rt_section_a_not_eligible').hide();
				// 	clear_afford();			
				// 	$('#rt_section_b').hide();	

				// // For International residents (individual or company application): If the FSCR is between 125% and 129.99%, then display the 'Results' section.                                                                                                                                                                                    
				// // For all UK or Expats, individual or company application: If FSCR is below 115%, display message 3                       
				// // For all International residents, individual or company application: If FSCR is below 125%, display message 3.
				// }else if(  (fscr>=1.15 && ($rt_application_type=='individual' || $rt_application_type=='expat')) || ($rt_application_type=='limited' && fscr>=1.10) ){
				// 	console.log('Show results / assessment form');
				// 	var indbasiccorp = ((mfro * 1.25) - $rt_monthly_rent);
				// 	var indhigher = (mfro * 1.45) - $rt_monthly_rent;
				// 	// console.log('indbasiccorp'+indbasiccorp);
				// 	// console.log('indhigher'+indhigher);
				// 	if($rt_application_type=='individual' && $rt_taxpayer_status=='higher'){
				// 		$('#rt_monthly_top_up_amount').html('£'+(Math.round(indhigher,2)));
				// 		$('#rt_expenses_rental_top_up').val(Math.round(indhigher,2));
				// 	}else{
				// 		$('#rt_monthly_top_up_amount').html('£'+(Math.round(indbasiccorp,2)));
				// 		$('#rt_expenses_rental_top_up').val(Math.round(indbasiccorp,2));
				// 	}
				// 	$('#rt_section_a_eligible').hide();
				// 	$('#rt_section_a_not_eligible').hide();
				// 	$('#rt_section_b').slideDown();	
				// // For individuals only: If FSCR is below 115%, display message 3 
				// }else if(fscr<1.15 && $rt_application_type=='individual') {					
				// 	console.log('FSCR is below 115');
				// 	$('#rt_section_a_eligible').hide();
				// 	$('#rt_section_a_not_eligible').slideDown();
				// 	clear_afford();			
				// 	$('#rt_section_b').hide();	
				// // For Corporate only: If FSCR is below 110%, display message 3
				// }else if($rt_application_type=='limited' && fscr<1.10) {
				// 	console.log('Corporate only < 110')
				// 	$('#rt_section_a_eligible').hide();
				// 	$('#rt_section_a_not_eligible').slideDown();
				// 	clear_afford();			
				// 	$('#rt_section_b').hide();	
				// }
			}

		}
	}else{
		$('#rt_ftv').val('');		
		$('#rt_ftv').removeClass('error');
		$('#rt_not_eligible_2').hide();
	}
});

// $('#rt_section_b input').on('change',function(e){
// 	$('#rt_income_total').html('');
// 	$('#rt_expenses_total').html('');
// 	$('#rt_remaining_income').html('');
// 	$('#rt_section_b_eligible').hide();
// 	$('#rt_section_b_not_eligible').hide();
// 	$('#calc_affordability_values').hide();
// });

$('#rt_section_b').on('keyup', 'input', function(e) {
	$('#rt_income_total').html('');
	$('#rt_expenses_total').html('');
	$('#rt_remaining_income').html('');
	$('#rt_section_b_eligible').hide();
	$('#rt_section_b_not_eligible').hide();
	$('#calc_affordability_values').hide();
});


$('#calc_affordability').on('click',function(e){
	e.preventDefault();
	// rt_section_b stuff
	$('#calc_affordability_values').slideDown();
	$('#rt_income_total').html('');
	$('#rt_expenses_total').html('');
	$('#rt_remaining_income').html('');
	var $rt_applicant_1_income= get_numeric_val('rt_applicant_1_income');
	var $rt_applicant_2_income= get_numeric_val('rt_applicant_2_income');
	var income = $rt_applicant_1_income + $rt_applicant_2_income;
	var expenses = get_numeric_val('rt_expenses_rental_top_up',0)
		+get_numeric_val('rt_expenses_1',0)+get_numeric_val('rt_expenses_2',0)+get_numeric_val('rt_expenses_3',0)+get_numeric_val('rt_expenses_4',0)+get_numeric_val('rt_expenses_5',0)
		+get_numeric_val('rt_expenses_6',0)+get_numeric_val('rt_expenses_7',0)+get_numeric_val('rt_expenses_8',0)+get_numeric_val('rt_expenses_9',0)+get_numeric_val('rt_expenses_10',0)
		+get_numeric_val('rt_expenses_11',0)+get_numeric_val('rt_expenses_12',0)+get_numeric_val('rt_expenses_13',0);
	var income = $rt_applicant_1_income + $rt_applicant_2_income;
	var remain = income - expenses;
	// $('#rt_income_total').val(Math.round(income,2));
	// $('#rt_expenses_total').val(Math.round(expenses,2));
	// $('#rt_remaining_income').val(Math.round(remain,2));
	$('#rt_income_total').html('£'+Math.round(income,2));
	$('#rt_expenses_total').html('£'+Math.round(expenses,2));
	$('#rt_remaining_income').html('£'+Math.round(remain,2));

	if(remain < 0){
		console.log('remain < 0');
		$('#rt_remaining_income').removeClass('text-pear-dark bg-white border-l-6 border-pear-dark')
		$('#rt_remaining_income').addClass('text-red bg-white border-l-6 border-red')
		// $('#rt_remaining_income').parent().addClass('error');
		$('#rt_section_b_eligible').hide();
		$('#rt_section_b_not_eligible').slideDown();
	}else{
		console.log('remain > 0');
		$('#rt_remaining_income').removeClass('text-red bg-white border-l-6 border-red')
		$('#rt_remaining_income').addClass('text-pear-dark bg-white border-l-6 border-pear-dark')
		// $('#rt_remaining_income').parent().removeClass('error');						
		$('#rt_section_b_eligible').slideDown();
		$('#rt_section_b_not_eligible').hide();
	}
});
// var rt_application_type = $('#rt_application_type');
// var rt_taxpayer_status = $('#rt_taxpayer_status');
// var rt_property_price = $('#rt_property_price');
// var rt_finance_needed = $('#rt_finance_needed');
// var rt_ftv = $('#rt_ftv');
// var rt_initial_product_rate = $('#rt_initial_product_rate');
// var rt_monthly_finance_rent_only = $('rt_monthly_finance_rent_only');

// var rt_monthly_rent = $('#rt_monthly_rent');
// var rt_fscr = $('#rt_fscr');
// var rt_monthly_finance = $('#rt_monthly_finance');
// var rt_section_a_eligible = $('#rt_section_a_eligible');
// var rt_section_a_not_eligible = $('#rt_section_a_not_eligible');
// var rt_section_b = $('#rt_section_b');
// var rt_monthly_top_up_amount = $('#rt_monthly_top_up_amount');
// var rt_applicant_1_income = $('#rt_applicant_1_income');
// var rt_applicant_2_income = $('#rt_applicant_2_income');
// var rt_expenses_rental_top_up = $('#rt_expenses_rental_top_up');
// var rt_expenses_1 = $('#rt_expenses_1');
// var rt_expenses_2 = $('#rt_expenses_2');
// var rt_expenses_3 = $('#rt_expenses_3');
// var rt_expenses_4 = $('#rt_expenses_4');
// var rt_expenses_5 = $('#rt_expenses_5');
// var rt_expenses_6 = $('#rt_expenses_6');
// var rt_expenses_7 = $('#rt_expenses_7');
// var rt_expenses_8 = $('#rt_expenses_8');
// var rt_expenses_9 = $('#rt_expenses_9');
// var rt_expenses_10 = $('#rt_expenses_10');
// var rt_expenses_11 = $('#rt_expenses_11');
// var rt_expenses_12 = $('#rt_expenses_12');
// var rt_income_total = $('#rt_income_total');
// var rt_expenses_total = $('#rt_expenses_total');
// var rt_remaining_income = $('#rt_remaining_income');



// ================================================================================================
// Buy to let calculator
// ================================================================================================


	// ================================================================================================
	// Custom rounding func
	// ================================================================================================

	function customRound(number, decimalPlaces) {
	    // If decimalPlaces is not provided, set it to 2
	    console.log(number);
	    decimalPlaces = (typeof decimalPlaces !== 'undefined') ? decimalPlaces : 0; //default to whole

	    var factor = Math.pow(10, decimalPlaces);
	    var adjustedNumber = number * factor;
	    var ret = 0;

	    if (adjustedNumber - Math.floor(adjustedNumber) > 0.01) {
	        ret = Math.ceil(adjustedNumber) / factor;
	    } else {
	        ret = Math.floor(adjustedNumber) / factor;
	    }
	    console.log(ret);
	    return ret;
	}


	// --------------------------------------------------------------------------------------------
	// SHOW NOTES
	$('.js-add-note').on('click',function(e){
		e.preventDefault();
		var $target = $(this).data('note');
		$('#'+$target).slideToggle();
	});
		

	// --------------------------------------------------------------------------------------------
	// TRIGGER
	$('.calculate-buy-to-let').on('click',function(e){calculate_buy_to_let(e);});
	$('#calculate_buy_to_let_form').on('submit',function(e){calculate_buy_to_let(e);});

    $('#calculate_buy_to_let_form').on('keypress', function(event) {
        if (event.which === 13) { // 13 is the Enter key
            event.preventDefault();
        }
    });

	// --------------------------------------------------------------------------------------------
	// SWITCH
	
	// --------------------------------------------------------------------------------------------
	// this is now always on:
	// $('input.five_year').on('change',function(e){
	// 	var $val = $('.five_year:checked').val();
	// 	if($val > 0){
	// 		$('.product_rate_container').slideDown();
	// 	}else{
	// 		$('.product_rate_container').slideUp();
	// 	}
	// });
	// --------------------------------------------------------------------------------------------

	$('input.individual_or_limited').on('change',function(e){
		var $val = $('input.individual_or_limited:checked').val();
		if($val == 'individual'){
			$('#residency_option').slideDown();
		}else{
			$('#residency_option').slideUp();
		}
	});
	
	$('input.otherresident').on('change',function(e){
		var $val = $('input.otherresident:checked').val();

		if($val == 'nonuk'){
			$('input.othertaxpayer').prop('disabled',true);
			$('input.othertaxpayer').parent().addClass('check-disabled');
			$('input.nonukpaxpater').prop('disabled',false);
			$('input.nonukpaxpater').parent().removeClass('check-disabled');
			$('input.nonukpaxpater').trigger('click');
		}else{
			$('input.othertaxpayer').prop('disabled',false);
			$('input.othertaxpayer').parent().removeClass('check-disabled');
		}
	});

	// --------------------------------------------------------------------------------------------
	// VARS
	var default_rate = window.default_rate;
	
	// old multipliers
	// var multiplier = window.multiplier;
	// var multiplier_btl = window.multiplier_btl;
	// var multiplier_hmo = window.multiplier_hmo;
	// var multiplier_expats = window.multiplier_expats;
		// new product multipliers for top up
	var topup_multiplier_ukAndLtdCompany = window.topup_multiplier_ukAndLtdCompany;
	var topup_multiplier_ukAndIndividual = window.topup_multiplier_ukAndIndividual;
	var topup_multiplier_internationalAndLtdCompany = window.topup_multiplier_internationalAndLtdCompany;
	var topup_multiplier_internationalAndIndividual = window.topup_multiplier_internationalAndIndividual;
	var topup_multiplier_expatAndIndividual = window.topup_multiplier_expatAndIndividual;
	var topup_multiplier_expatAndLtdCompany = window.topup_multiplier_expatAndLtdCompany;

	// new multipliers
	var multiplier_ltd_ukBtl = window.topup_multiplier_ltd_ukBtl;
	var multiplier_ltd_ukHmoMufb = window.topup_multiplier_ltd_ukHmoMufb;
	var multiplier_ltd_expatBtl = window.topup_multiplier_ltd_expatBtl;
	var multiplier_ltd_expatHmoMufb = window.topup_multiplier_ltd_expatHmoMufb;
	var multiplier_ltd_intBtl = window.topup_multiplier_ltd_intBtl;
	var multiplier_ltd_intHmoMufb = window.topup_multiplier_ltd_intHmoMufb;
	var multiplier_ukBasic_ukBtl = window.topup_multiplier_ukBasic_ukBtl;
	var multiplier_ukBasic_ukHmoMufb = window.topup_multiplier_ukBasic_ukHmoMufb;
	var multiplier_ukBasic_expatBtl = window.topup_multiplier_ukBasic_expatBtl;
	var multiplier_ukBasic_expatHmoMufb = window.topup_multiplier_ukBasic_expatHmoMufb;
	var multiplier_ukBasic_intBtl = window.topup_multiplier_ukBasic_intBtl;
	var multiplier_ukBasic_intHmoMufb = window.topup_multiplier_ukBasic_intHmoMufb;
	var multiplier_ukHigher_ukBtl = window.topup_multiplier_ukHigher_ukBtl;
	var multiplier_ukHigher_ukHmoMufb = window.topup_multiplier_ukHigher_ukHmoMufb;
	var multiplier_ukHigher_expatBtl = window.topup_multiplier_ukHigher_expatBtl;
	var multiplier_ukHigher_expatHmoMufb = window.topup_multiplier_ukHigher_expatHmoMufb;
	var multiplier_ukHigher_intBtl = window.topup_multiplier_ukHigher_intBtl;
	var multiplier_ukHigher_intHmoMufb = window.topup_multiplier_ukHigher_intHmoMufb;
	var multiplier_nonUk_ukBtl = window.topup_multiplier_nonUk_ukBtl;
	var multiplier_nonUk_ukHmoMufb = window.topup_multiplier_nonUk_ukHmoMufb;
	var multiplier_nonUk_expatBtl = window.topup_multiplier_nonUk_expatBtl;
	var multiplier_nonUk_expatHmoMufb = window.topup_multiplier_nonUk_expatHmoMufb;
	var multiplier_nonUk_intBtl = window.topup_multiplier_nonUk_intBtl;
	var multiplier_nonUk_intHmoMufb = window.topup_multiplier_nonUk_intHmoMufb;

	// --------------------------------------------------------------------------------------------
	// CALCULATE
	function calculate_buy_to_let(e){

		e.preventDefault();

		if(!$('#product_rate').val()) $('#product_rate').val(default_rate);

		var $individual_or_limited	= get_check('individual_or_limited', true);
		var $type					= get_check('type', true);
		var $resident				= get_check('resident', true);
		var $five_year				= get_check('five_year', true);
		var $product_rate			= clean_numeric( 'product_rate', true );
		var $total_finance			= clean_numeric( 'total_finance', true );
		var $monthly_rental			= clean_numeric( 'monthly_rental', true );
		
		// only check this if individual
		var $tax_payer = '';
		if($individual_or_limited=='individual'){
			var $tax_payer			= get_check('tax_payer', true);
		}		

		var $is_five_year = ($('.five_year:checked').val() == "1");
		// if( !$is_five_year ) $product_rate = default_rate;
		
		// new - use default rate if higher
		if($product_rate < default_rate && !$is_five_year) $product_rate = default_rate;

		$('#buy_to_let_values').slideUp();


		if( $individual_or_limited < 0 || ($individual_or_limited!='limited' && $tax_payer < 0) || $resident < 0 || $type < 0 || $five_year < 0 ){
			$('#form_error').slideDown();
			$('#result_area').slideUp();
			$('#form_error_values').slideUp();
			return false;
		// }else if($product_rate<=0 || ($product_rate==0 && !$is_five_year ) ){
		}else if($product_rate<=0 || ($product_rate==0) ){
			$('#form_error').slideDown();
			$('#result_area').slideUp();
			$('#form_error_values').slideUp();
			$('#product_rate').parent().addClass('error');
		}else if(($total_finance == 0 && $monthly_rental == 0)){ //|| $total_finance > 0 && $monthly_rental > 0 
			$('#form_error').slideDown();
			$('#result_area').slideUp();
			$('#form_error_values').slideDown();
			return false;
		}else{
			$('#result_area').slideDown();
			$('#form_error').slideUp();
			$('#form_error_values').slideUp();

			$result1 = $result2 = '&ndash;';

			//which multiplier?
			// $multiplier = multiplier; // %145
			$multiplier = 145;

			if( $individual_or_limited=='limited' ){
				// limited
				if( $resident=='uk' || $resident=='' ){
					// uk resident
					if( $type=='hmomufb' ) { $multiplier = multiplier_ltd_ukHmoMufb; console.log('multiplier: ltd_ukHmoMufb'); }
					if( $type=='buytolet' ) { $multiplier = multiplier_ltd_ukBtl; console.log('multiplier: ltd_ukBtl'); }
				}
				if( $resident=='ukexpat' ){
					// uk expat
					if( $type=='hmomufb' ) { $multiplier = multiplier_ltd_expatHmoMufb; console.log('multiplier: ltd_expatHmoMufb'); }
					if( $type=='buytolet' ) { $multiplier = multiplier_ltd_expatBtl; console.log('multiplier: ltd_expatBtl'); }
				}
				if( $resident=='nonuk' ){
					// international
					if( $type=='hmomufb' ) { $multiplier = multiplier_ltd_intHmoMufb; console.log('multiplier: ltd_intHmoMufb'); }
					if( $type=='buytolet' ) { $multiplier = multiplier_ltd_intBtl; console.log('multiplier: ltd_intBtl'); }
				}
			}
			else if($individual_or_limited=='individual'){
				// personal
				if( $tax_payer=='basic' ){
					// basic rate tax payer
					if( $resident=='uk' && $type=='buytolet' ) { $multiplier = multiplier_ukBasic_ukBtl; console.log('multiplier: ukBasic_ukBtl'); }
					if( $resident=='uk' && $type=='hmomufb' ) { $multiplier = multiplier_ukBasic_ukHmoMufb; console.log('multiplier: ukBasic_ukHmoMufb'); }
					if( $resident=='ukexpat' && $type=='buytolet' ) { $multiplier = multiplier_ukBasic_expatBtl; console.log('multiplier: ukBasic_expatBtl'); }
					if( $resident=='ukexpat' && $type=='hmomufb' ) { $multiplier = multiplier_ukBasic_expatHmoMufb; console.log('multiplier: ukBasic_expatHmoMufb'); }
					if( $resident=='nonuk' && $type=='buytolet' ) { $multiplier = multiplier_ukBasic_intBtl; console.log('multiplier: ukBasic_intBtl'); }
					if( $resident=='nonuk' && $type=='hmomufb' ) { $multiplier = multiplier_ukBasic_intHmoMufb; console.log('multiplier: ukBasic_intHmoMufb'); }
				}
				if( $tax_payer=='nonuk' ){
					// non uk tax payer
					if( $resident=='uk' && $type=='buytolet' ) { $multiplier = multiplier_nonUk_ukBtl; console.log('multiplier: nonUk_ukBtl'); }
					if( $resident=='uk' && $type=='hmomufb' ) { $multiplier = multiplier_nonUk_ukHmoMufb; console.log('multiplier: nonUk_ukHmoMufb'); }
					if( $resident=='ukexpat' && $type=='buytolet' ) { $multiplier = multiplier_nonUk_expatBtl; console.log('multiplier: nonUk_expatBtl'); }
					if( $resident=='ukexpat' && $type=='hmomufb' ) { $multiplier = multiplier_nonUk_expatHmoMufb; console.log('multiplier: nonUk_expatHmoMufb'); }
					if( $resident=='nonuk' && $type=='buytolet' ) { $multiplier = multiplier_nonUk_intBtl; console.log('multiplier: nonUk_intBtl'); }
					if( $resident=='nonuk' && $type=='hmomufb' ) { $multiplier = multiplier_nonUk_intHmoMufb; console.log('multiplier: nonUk_intHmoMufb'); }
				}
				if( $tax_payer=='higher' ){
					// higher rate
					if( $resident=='uk' && $type=='buytolet' ) { $multiplier = multiplier_ukHigher_ukBtl; console.log('multiplier: ukHigher_ukBtl'); }
					if( $resident=='uk' && $type=='hmomufb' ) { $multiplier = multiplier_ukHigher_ukHmoMufb; console.log('multiplier: ukHigher_ukHmoMufb'); }
					if( $resident=='ukexpat' && $type=='buytolet' ) { $multiplier = multiplier_ukHigher_expatBtl; console.log('multiplier: ukHigher_expatBtl'); }
					if( $resident=='ukexpat' && $type=='hmomufb' ) { $multiplier = multiplier_ukHigher_expatHmoMufb; console.log('multiplier: ukHigher_expatHmoMufb'); }
					if( $resident=='nonuk' && $type=='buytolet' ) { $multiplier = multiplier_ukHigher_intBtl; console.log('multiplier: ukHigher_intBtl'); }
					if( $resident=='nonuk' && $type=='hmomufb' ) { $multiplier = multiplier_ukHigher_intHmoMufb; console.log('multiplier: ukHigher_intHmoMufb'); }
				}
			}
			
			// A and B
			// if( $type=='buytolet' 
				// && ( ($individual_or_limited=='limited') || (($resident=='uk' || $resident=='ukexpat') && $tax_payer=='basic')    )
			// ) {$multiplier = multiplier_btl; console.log('multiplier_btl - rule A and B'); } // %125}

			// C 1
			// f( $type=='buytolet' && $tax_payer=='nonuk' 
				 // && ( $resident=='nonuk' || $resident=='ukexpat') && $tax_payer=='nonuk' && $individual_or_limited=='individual'
			// ) {$multiplier = multiplier_expats; console.log('multiplier_expats - rule C1'); } // %130}

			// C 2
			// else if( $type=='buytolet' && $resident=='nonuk' 
				// && ( $tax_payer=='basic' || $tax_payer=='higher' )
			// ) {$multiplier = multiplier_expats; console.log('multiplier_expats - rule C2'); } // %130}
			
			// D
			// if( $type=='hmomufb' 
				 // && ( ($individual_or_limited=='limited') || ($resident=='uk' && $tax_payer=='basic') )
			// ) {$multiplier = multiplier_hmo; console.log('multiplier_hmo - rule D'); } // %140}


			// ------------------------------------------
			// total finance & $monthly_rental
			if($total_finance){
				// $result1 = '£'+formatNumber(Math.floor(($total_finance * (($product_rate/100)/12)*($multiplier/100))+1));
				$result1 = '£' + formatNumber(customRound(($total_finance * (($product_rate/100)/12)*($multiplier/100)) ),0);
			}
			if($monthly_rental){
				$result2 = '£'+formatNumber(Math.floor(($monthly_rental /($multiplier/100)*12/($product_rate/100))));
				// $result2 = '£' + formatNumber(customRound(($monthly_rental / ($multiplier / 100) * 12 / ($product_rate / 100))),0);
			}

			console.log('multiplier',$multiplier);
			
			// top up multipliers
			$result3 = $result4 = '&ndash;';
			$('#further_calc').hide();			
			$('#buy_to_let_values').hide();
			$('.buy_to_let_values').hide();
			// alert($resident);
			if( $type=='buytolet') {
				var tum = 1;
				if ($resident=='uk'){
					tum = topup_multiplier_ukAndIndividual;
					if($individual_or_limited=='limited'){
						tum = topup_multiplier_ukAndLtdCompany;
					}
				} else if ($resident=='ukexpat'){
					// ukexpat
					tum = topup_multiplier_expatAndIndividual;
					if($individual_or_limited=='limited'){
						tum = topup_multiplier_expatAndLtdCompany
					}
				}else{ // international
					tum = topup_multiplier_internationalAndIndividual;
					if($individual_or_limited=='limited'){
						tum = topup_multiplier_internationalAndLtdCompany
					}	
				}
				if($total_finance){
					// Calculation:  {Rent required} = ((Finance Amount x 0.055)/12) x 1.10
					// $result3 = '£'+formatNumber( Math.floor(($total_finance * ((($product_rate/100)/12)*tum))+1));
					$result3 = '£' + formatNumber(customRound(($total_finance * ((($product_rate / 100) / 12) * tum)) ),0);

				}
				if($monthly_rental){
					// Calculation:  {Maximum Finance Amount} = ((Estimated monthly rental x 12)/1.15)/5.5%
					$result4 = '£'+formatNumber(Math.floor( (($monthly_rental*12)/tum)/($product_rate/100)) );
					// $result4 = '£' + formatNumber(customRound((($monthly_rental * 12) / tum) / ($product_rate / 100)),0);
				}
				// UPDATE: NOW ONLY WHERE VALUES ARE SET
				if(tum > 1){
					$('#buy_to_let_values').slideDown();
					$('.buy_to_let_values').slideDown();
					$('#further_calc').show();			
				}
				console.log('Top up multiplier = '+tum);
			}

			$('#result1').html($result1);
			$('#result2').html($result2);
			$('#result3').html($result3);
			$('#result4').html($result4);

			// ============================================================
			// Rental Top Up suitability - all vars are RT_
			// ============================================================
			// FIRST LET'S SEE IF IT SHOUDL DISPLAY:
			// All applicants are UK resident?
			// 
			// At least one applicant has a gross annual income of £35,000?
			// The finance application is for a Buy-to-Let property?


		}

		return false;

	}





// ================================================================================================
// Buy to let print
// ================================================================================================

	$('body').on('click', '.calculate_buy_to_let_form_print', function(e){
	    e.preventDefault();
    	var formData = serializeFormWithLabels('#calculate_buy_to_let_form');
		formData['result1'] = $('#result1').html();
		formData['result3'] = $('#result3').html();
		formData['result2'] = $('#result2').html();
		formData['result4'] = $('#result4').html();
		formData['rt_monthly_top_up_amount'] = $('#rt_monthly_top_up_amount').html();
		formData['rt_income_total'] = $('#rt_income_total').html();
		formData['rt_expenses_total'] = $('#rt_expenses_total').html();
		formData['rt_remaining_income'] = $('#rt_remaining_income').html();
		formData['min_gross_income'] = $('#min_gross_income').val();

		var messaging = '';
		$('.messaging:visible').each(function() {
		    messaging = messaging + $(this).html() + ' ';
		});
		formData['messaging'] = messaging;
	    $.ajax({
	        type: 'POST',
	        url: '/form-pdf/buy-to-let-form-pdf/generate-buy-to-let-form-pdf', // Adjust the URL to your plugin's controller action
	        data: formData,
	        success: function(response) {
			    // Submit the form directly
	            var newForm = $('<form>');
	            newForm.attr('action', '/form-pdf/buy-to-let-form-pdf/generate-buy-to-let-form-pdf');
	            newForm.attr('method', 'POST');
	            newForm.attr('target', '_blank'); // Open in a new tab/window
	            
	            // Add input fields based on the form data
	            $.each(formData, function(name, value) {
	                var input = $('<input>');
	                input.attr('type', 'hidden');
	                input.attr('name', name);
	                input.val(value);
	                newForm.append(input);
	            });
	            
	            // Append the new form to the body and submit it
	            $('body').append(newForm);
	            newForm.submit();
	        },
	        error: function(){
	        	alert('Sorry, we were unable to download your form.');
	        }
	    });
	});

	// Serialize form data with labels for radio and checkbox inputs
	function serializeFormWithLabels(form) {
	    var formData = {};

	    // Iterate over each form element
	    $(form).find(':input').each(function() {
	        var name = $(this).attr('name');
	        var value;

	        if ((this.type === 'radio' || this.type === 'checkbox') ) {
	        	// alert(this.type);
	        	if($(this).is(':checked')){
	            	value = $(this).parent().text().trim();
	        	}else{
	        		value = false;
	        	}
	        	// alert(value);
	        } else {
	            // For other inputs, use their value
	            value = $(this).val();
	        }

	        // For radio and checkbox inputs, use label text instead of value
	        // if (this.type === 'radio' || this.type === 'checkbox') {
	            // value = $(this).closest('label').text().trim();
	        // } else {
	            // value = $(this).val();
	        // }

	        // Add the name-value pair to formData
	        if (name && value) {
	            formData[name] = value;
	        }
	    });

	    return formData;
	}

// ================================================================================================
// Finance calculator
// ================================================================================================


	// --------------------------------------------------------------------------------------------
	// TRIGGER
	$('.calculate-finance').on('click',function(e){calculate_finance(e);});
	$('#calculate_finance_form').on('submit',function(e){calculate_finance(e);});

	// --------------------------------------------------------------------------------------------
	// VARS
	var finance_multiplier = window.finance_multiplier;

	// --------------------------------------------------------------------------------------------
	// CALCULATE
	function calculate_finance(e){
		e.preventDefault();

		var $income_1			= clean_numeric( 'income_1', true );
		var $income_other_1		= clean_numeric( 'income_other_1', true );
		var $income_2			= clean_numeric( 'income_2', true );
		var $income_other_2		= clean_numeric( 'income_other_2', true );
		var $finance_1			= clean_numeric( 'finance_1', true );
		var $credit_1			= clean_numeric( 'credit_1', true );
		var $commitments_1		= clean_numeric( 'commitments_1', true );
		var $finance_2			= clean_numeric( 'finance_2', true );
		var $credit_2			= clean_numeric( 'credit_2', true );
		var $commitments_2		= clean_numeric( 'commitments_2', true );

		if( $income_1 < 0 || $income_other_1 < 0 || $income_2 < 0 || $income_other_2 < 0 || $finance_1 < 0 || $credit_1 < 0 || $commitments_1 < 0 || $finance_2 < 0 || $credit_2 < 0 || $commitments_2 < 0 ){
			$('#form_error').slideDown();
			$('#result_area').slideUp();
			// alert('bad');
			return false;
		}else if( $income_1 == 0 && $income_other_1 == 0 && $income_2 == 0 && $income_other_2 == 0 && $finance_1 == 0 && $credit_1 == 0 && $commitments_1 == 0 && $finance_2 == 0 && $credit_2 == 0 && $commitments_2 == 0 ){
			return;
		}else{
			$('#form_error').slideUp();
			//do calc 

			var $result = (
				($income_1 + $income_other_1 + $income_2 + $income_other_2)
				- ( 12 * 
					($finance_1 + $credit_1 + $commitments_1 + $finance_2 + $credit_2 + $commitments_2) 
				)
			) * finance_multiplier

			$result = parseInt($result);

			if($result<0) $result =0;

			$('#result').html('&pound;'+formatNumber($result));
			$('#result_area').slideDown();
			// alert('good');
			
			return true;
		}

	}


// ================================================================================================
// How much will it cost me calculator
// ================================================================================================

	// --------------------------------------------------------------------------------------------
	// TRIGGER
	$('.calculate-how-much').on('click',function(e){calculate_how_much(e);});
	$('#calculate_how_much_form').on('submit',function(e){calculate_how_much(e);});

	// --------------------------------------------------------------------------------------------
	// VARS
	var how_much_multiplier = window.how_much_multiplier;

	// --------------------------------------------------------------------------------------------
	// CALCULATE
	function calculate_how_much(e){
		e.preventDefault();

		var $hp_or_btl		= get_check('hp_or_btl', true);
		var $ar_or_r		= get_check('ar_or_r', true);
		var $finance 		= clean_numeric( 'finance', true );
		var $years			= clean_numeric( 'years', true );

		if( $finance < 0 || $years < 0 || $hp_or_btl=='-1' || $ar_or_r=='-1' ){
			// console.log('nope');
			$('#form_error').slideDown();
			$('#result_area').slideUp();
			return false;

		}else{			
			

			$('.initial-rental-rate').each(function(){
				var $rate = $(this).data('rate');
				console.log($ar_or_r);
				if($ar_or_r == 'ar'){
					// console.log('ar'+$ar_or_r);
					var $months = $years*12;
					var $formula_1 = ($rate/1200);
					var $formula_2 = Math.pow(($formula_1+1),$months);
					var $formula_3 = ($formula_1*$formula_2)/($formula_2-1);
					var $result = ($finance * $formula_3) +0.005;
					$(this).html(formatNumber(parseFloat($result).toFixed(2)));

					// var $result = ($finance * $formula_3);
					// console.log($result);
				}else{
					$result = ($finance * ($rate/100))/12;
					$result = $result + 0.005;
					// $('#result').html('&pound;'+formatNumber($result));
					$(this).html(formatNumber(parseFloat($result).toFixed(2)));
				}
			});
			$('#form_error').slideUp();
			$('#text_type').html( ($hp_or_btl=='btl'?'Buy-To-Let':'Home Purchase') );
			$('#text_amount').html( formatNumber($finance) );
			$('#text_term').html( $years );
			$('#text_agreement').html( ($ar_or_r=='r'?'Rent Only':'Acquisition &amp; Rent') );

			$('#btl-table').hide(); $('#hp-table').hide();
			if($hp_or_btl=='btl'){ $('#btl-table').show(); } else { $('#hp-table').show(); }

			$('#result_area').slideDown();
			return true;
		}

	}




// ================================================================================================
// overpayment calculator
// ================================================================================================
	
	// --------------------------------------------------------------------------------------------
	// TRIGGER
	$('body').on('click','.calculate-overpayment',function(e){calculate_overpayment(e);});
	$('body').on('click','.calculate-overpayment',function(e){calculate_overpayment(e);});
	$('body').on('submit','#calculate_overpayment_form',function(e){calculate_overpayment(e);});
	// hide on change
	$('body').on('change','#acquisition_and_rent',function(e){$('#result_area').slideUp();});
	$('body').on('change','#rent_only',function(e){$('#result_area').slideUp();});
	$('body').on('change','#remaining_finance',function(e){$('#result_area').slideUp();});
	$('body').on('change','#remaining_years',function(e){$('#result_area').slideUp();});
	$('body').on('change','#remaining_months',function(e){$('#result_area').slideUp();});
	$('body').on('change','#rental_rate',function(e){$('#result_area').slideUp();});
	$('body').on('change','#app_amount',function(e){$('#result_area').slideUp();});


	// --------------------------------------------------------------------------------------------
	// SWITCH
	$('.js-acquisition_or_rent_only').on('change',function(e){
		
		if($('#acquisition_and_rent').prop('checked')){
			$('#aor_a').removeClass('hidden');
			$('#aor_r').addClass('hidden');
		}else{
			$('#aor_a').addClass('hidden');
			$('#aor_r').removeClass('hidden');
		}
	});


	// --------------------------------------------------------------------------------------------
	// VARS
	// acquisition_or_rent_only

	// --------------------------------------------------------------------------------------------
	// FUNCTIONBS
	function calc_interest(rate,loan,payments)
	{
		var pre = 0;
		var interest = 0;
		var curloan = loan;
		// add interest
		while (curloan > 0){
			pre = curloan;
			curloan = curloan + (curloan * rate);
			interest = interest + (curloan - pre);
			if(payments>curloan)payments = curloan;
			curloan = curloan - payments;
		}
		return interest;
	}	
	function calc_iterations(rate,loan,payments)
	{
		var pre = 0;
		var i = 0;
		var interest = 0;
		var curloan = loan;
		// add interest
		while (curloan > 0){
			pre = curloan;
			curloan = curloan + (curloan * rate);
			interest = interest + (curloan - pre);
			if(payments>curloan)payments = curloan;
			curloan = curloan - payments;
			i++;
		}
		return i;
	}	

	// --------------------------------------------------------------------------------------------
	// CALCULATE
	function calculate_overpayment(e){

		var $remaining_finance		= clean_numeric( 'remaining_finance', true );
		var $remaining_years		= clean_numeric( 'remaining_years', true ); 
		var $remaining_months		= clean_numeric( 'remaining_months', true ); 
		var $rental_rate			= clean_numeric( 'rental_rate', true ); 
		var $app_amount				= clean_numeric( 'app_amount', true ); 

		var errors = '';
		if (   $remaining_finance <= 1000 ) { errors += '<li>Your outstanding finance amount seems to low.</li>'; }
		if (   $remaining_years <= 0 || ($remaining_years == 0 && $remaining_months < 12) ) { errors += '<li>Your remaining term is too short.</li>'; }
		if (   $app_amount <= 1000 ) { errors += '<li>Your Additional Acquisition Payment (AAP) amount is below our minimum.</li>'; }
		if (   $app_amount > $remaining_finance ) { errors += '<li>Your Additional Acquisition Payment (AAP) is greater than the outstanding finance.</li>'; }
		if (   $rental_rate < 0 || $rental_rate > 15 ) { errors += '<li>Your current rental rate is out of range.</li>'; }
		
		$('#form_errors').html(errors);

		if(errors) {
			$('#form_error').slideDown();
			return false;
		}

		var rate = ($rental_rate / 12) / 100;
		var periods = $remaining_months + ( $remaining_years * 12 );
		var remaining = $remaining_finance;
		var start = 1;  // Start period: 1
		var type = 0;  // interest added at end of period?
		var end = periods;  // End period: 264
		var cumipmt = CUMIPMT(rate, periods, remaining, start, end, type);

		var oldrate = PMT( rate, periods, remaining )
		var newrate = PMT( rate, periods, remaining - $app_amount )

		var $boxa = ABS( oldrate );
		var $boxb = ABS( cumipmt ) ;

		var $boxf = ABS( newrate );

		// var $boxg = (periods * ABS(oldrate)) - (periods * ABS(newrate)) - $app_amount;
		var $boxg = $boxb;

		var interest = calc_interest( rate, remaining, $boxa);
		var saved_interest = calc_interest( rate, remaining-$app_amount, $boxa);
		
		var payments = calc_iterations( rate, remaining, $boxa);
		var payments_lowered = calc_iterations( rate, remaining-$app_amount, $boxa);
		var payments_saved = payments - payments_lowered;

		var remaining = remaining - $app_amount;
		var cumipmt_reduced = CUMIPMT(rate, periods, remaining, start, end, type);
		var $boxh = ABS( cumipmt - cumipmt_reduced ) ;

		var $boxc = interest-saved_interest;

		// var $boxb = ABS( CUMIPMT( rate, periods, remaining, 1 , $remaining_months + ( $remaining_years * 12 )) );


		var $boxi = $remaining_finance * rate;
		var $boxj = ($remaining_finance - $app_amount) * rate;
		var $boxk = $app_amount * rate * 12;

		// console.log('$boxa:'+$boxa);
		// console.log('$boxb:'+$boxb);
		// console.log('$boxc:'+$boxc);
		// console.log('$boxd:'+$boxd);
		// console.log('$boxe:'+$boxe);
		// console.log('$boxf:'+$boxf);
		// console.log('$boxg:'+$boxg);
		// console.log('$boxh:'+$boxh);
		// console.log('$boxi:'+$boxi);
		// console.log('$boxj:'+$boxj);
		// console.log('$boxk:'+$boxk);

		var $boxd = Math.floor(payments_saved/12);
		var $boxe = payments_saved%12;

		$('#res_cur_payment').html('£'+formatNumber(parseFloat($boxa).toFixed(0)));
		$('#res_cur_rent').html('£'+formatNumber(parseFloat($boxb).toFixed(0)));
		$('#res_rent_save').html('£'+formatNumber(parseFloat($boxc).toFixed(0)));
		$('#res_term_red_y').html($boxd);
		$('#res_term_red_m').html($boxe);

		$('#res_pr_cur_payment').html('£'+formatNumber(parseFloat($boxf).toFixed(0)));
		$('#res_pr_cur_rent').html('£'+formatNumber(parseFloat($boxg).toFixed(0)));;
		$('#res_pr_rent_save').html('£'+formatNumber(parseFloat($boxh).toFixed(0)));
		
		$('#res_ro_cur_payment').html('£'+formatNumber(parseFloat($boxi).toFixed(0)));
		$('#res_ro_new_payment').html('£'+formatNumber(parseFloat($boxj).toFixed(0)));
		$('#res_ro_rent_save').html('£'+formatNumber(parseFloat($boxk).toFixed(0)));

		$('#form_error').slideUp();
		$('#result_area').slideDown();

        $('html, body').animate({
            scrollTop: $("#rz").offset().top
        }, 500);
		
	}



// ================================================================================================
// Rental yield calculator
// ================================================================================================
	
	// --------------------------------------------------------------------------------------------
	// TRIGGER
	$('.calculate-rental-yield').on('click',function(e){calculate_rental_yield(e);});
	$('#calculate_rental_yeild_form').on('submit',function(e){calculate_rental_yield(e);});

	// --------------------------------------------------------------------------------------------
	// SWITCH
	$('.toggle-ppc').on('click',function(e){
		e.preventDefault();
		$('.ppc').slideToggle();
		$('.ppc_expanded').slideToggle();
		$(this).children('span').toggleClass('ico-plus ico-minus');
		$(this).toggleClass('bg-sea bg-sky');
		window.purchase_expanded = $(this).children('span').hasClass('ico-minus');
	});
	$('.toggle-ac').on('click',function(e){
		e.preventDefault();
		$('.ac').slideToggle();
		$('.ac_expanded').slideToggle();
		$(this).children('span').toggleClass('ico-plus ico-minus');
		$(this).toggleClass('bg-sea bg-sky');
		window.cost_expanded = $(this).children('span').hasClass('ico-minus');
	});

	$('input.purchase_or_owned').on('change',function(e){
		$('.owned').toggle();
		$('.purchase').toggle();
	});

	// --------------------------------------------------------------------------------------------
	// VARS
	var purchase_or_owned = window.purchase_or_owned;
	// var purchase_expanded = window.purchase_expanded;
	// var cost_expanded = window.cost_expanded;

	// --------------------------------------------------------------------------------------------
	// CALCULATE
	function calculate_rental_yield(e){
		e.preventDefault();
		var $purchase_or_owned			= get_check('purchase_or_owned', true);
		var $current_property_value		= clean_numeric( 'current_property_value', true ); 
		var $property_purchase_costs	= clean_numeric( 'property_purchase_costs', true ); 
		var $purchase_cost_1			= clean_numeric( 'purchase_cost_1', true ); 
		var $purchase_cost_2			= clean_numeric( 'purchase_cost_2', true ); 
		var $purchase_cost_3			= clean_numeric( 'purchase_cost_3', true ); 
		var $purchase_cost_4			= clean_numeric( 'purchase_cost_4', true ); 
		var $purchase_cost_5			= clean_numeric( 'purchase_cost_5', true ); 
		var $purchase_cost_6			= clean_numeric( 'purchase_cost_6', true ); 
		var $purchase_cost_7			= clean_numeric( 'purchase_cost_7', true ); 
		var $purchase_cost_8			= clean_numeric( 'purchase_cost_8', true ); 
		var $annual_costs				= clean_numeric( 'annual_costs', true ); 
		var $annual_cost_1_monthly		= clean_numeric( 'annual_cost_1_monthly', true );
		var $annual_cost_2				= clean_numeric( 'annual_cost_2', true );
		var $annual_cost_3				= clean_numeric( 'annual_cost_3', true );
		var $annual_cost_4				= clean_numeric( 'annual_cost_4', true );
		var $annual_cost_5				= clean_numeric( 'annual_cost_5', true );
		var $annual_cost_6				= clean_numeric( 'annual_cost_6', true );
		var $annual_cost_7				= clean_numeric( 'annual_cost_7', true );
		var $annual_cost_8				= clean_numeric( 'annual_cost_8', true );
		var $annual_cost_9				= clean_numeric( 'annual_cost_9', true );
		var $monthly_rent				= clean_numeric( 'monthly_rent', true );

		var $purchase_expanded			= window.purchase_expanded;
		var $cost_expanded				= window.cost_expanded;

		// console.log('purchase_expanded '+$purchase_expanded);
		// console.log('cost_expanded '+$cost_expanded);

		if($property_purchase_costs < 0 || $purchase_cost_1 < 0 || $purchase_cost_2 < 0 || $purchase_cost_3 < 0 || $purchase_cost_4 < 0 || $purchase_cost_5 < 0 || 
			$purchase_cost_6 < 0 || $purchase_cost_7 < 0 || $purchase_cost_8 < 0 || $annual_costs < 0 || $annual_cost_1_monthly < 0 || $annual_cost_2 < 0 || 
			$annual_cost_3 < 0 || $annual_cost_4 < 0 || $annual_cost_5 < 0 || $annual_cost_6 < 0 || $annual_cost_7 < 0 || $annual_cost_8 < 0 || $annual_cost_9 < 0 || $monthly_rent< 0){
			// dodgy field
			$('#form_error').slideDown();
			$('#result_area').slideUp();
			return false;
			
		}else{

			var $total_purchase = $current_property_value;
			if($purchase_or_owned == 'purchase'){
				var $total_purchase = $property_purchase_costs;
				if($purchase_expanded){
					$total_purchase = $purchase_cost_1 + $purchase_cost_2 + $purchase_cost_3 + $purchase_cost_4 + $purchase_cost_5 + $purchase_cost_6 + $purchase_cost_7 + $purchase_cost_8;
				}
			}

			var $total_annual = $annual_costs;
			if($cost_expanded){
				$total_annual = ($annual_cost_1_monthly*12) + $annual_cost_2 + $annual_cost_3 + $annual_cost_4 + $annual_cost_5 + $annual_cost_6 + $annual_cost_7 + $annual_cost_8 + $annual_cost_9;
			}

			// console.log('total_annual '+$total_annual);
			// console.log('total_purchase '+$total_purchase);

			if($total_purchase <1 || $monthly_rent<1) {
				$('#result_area').slideUp();
				$('#form_error').slideDown();
				return false;
			}

			$gross = ($monthly_rent*12)/$total_purchase;

			$net = (($monthly_rent*12)-$total_annual)/$total_purchase;

			$('#result_gross').html(formatNumber(parseFloat($gross*100).toFixed(2))+'%');
			$('#result_net').html(formatNumber(parseFloat($net*100).toFixed(2))+'%');

			$('#form_error').slideUp();
			$('#result_area').slideDown();
		}

	}


});



function formatNumber(x, decPlaces) {
	var split =	String(x).split('.');
    var s = '';
    var i = split[0].length;
    var j;
    // console.log(x);

    while (i > 3) {
        j = i - 3;
        s = ',' + split[0].slice(j, i) + s;
        i = j;
    }
    s = split[0].slice(0, i) + s;
    split[0] = s;

	if(split.length==2){
		if (decPlaces !== undefined) {
			if(decPlaces==0){
	   			return split[0];
			}
			var length = split[1].toString().length;
			var decimal = Number(split[1]) / Math.pow(10, length);
			split[1] = decimal.toFixed(decPlaces);
			if(split[1]>=1){
				split[1] = 0;
				split[0] ++;
			}
			split[1] = split[1].toString().replace(/^0\./, '');	
    		split[1] = split[1].padEnd(decPlaces, '0');
    	}
    	return split.join('.');
	}else{
		if (decPlaces !== undefined && decPlaces>0){
   			return split[0]+'.'+('0'.repeat(decPlaces));
		}else{
   			return split[0];
		}
	}

}


// function formatNumber(x, decPlaces, sep, grp) {
//     var sx = String(x).split('.');
//     var s = '';
//     var i = sx[0].length;
//     var j;

//     sep = sep || ',';
//     grp = grp || 3;

//     while (i > grp) {
//         j = i - grp;
//         s = sep + sx[0].slice(j, i) + s;
//         i = j;
//     }
//     s = sx[0].slice(0, i) + s;
//     sx[0] = s;

//     if (decPlaces !== undefined) {
//         sx[1] = sx[1] && sx[1].length ? parseFloat('0.' + sx[1]).toFixed(decPlaces).split('.')[1] : '0'.repeat(decPlaces);
//     } else {
//         if (sx[1]) {
//             sx[1] = parseFloat('0.' + sx[1]).toFixed(2).split('.')[1];
//         }
//     }

// 	var val = sx[1] || sx[1] === '' ? sx.join('.') : sx[0];
// 	if (val.endsWith('.')) {
//         return val.slice(0, -1);
//     }
//     return val;

//  }


// function formatNumber(x, sep, grp) {
//     var sx = (''+x).split('.'), s = '', i, j;
//     sep || (sep = ','); // default seperator
//     grp || grp === 0 || (grp = 3); // default grouping
//     i = sx[0].length;
//     while (i > grp) {
//         j = i - grp;
//         s = sep + sx[0].slice(j, i) + s;
//         i = j;
//     }
//     s = sx[0].slice(0, i) + s;
//     sx[0] = s;
//     if(sx[1]){ sx[1] = sx[1].substring(0,2); }
//     var returns = sx.join('.');
//     return returns.replace(/^,+/g, '');
// }